import API_END_POINTS from "../../utilities/Constants/ApiEndpoints";
import { baseApi } from "./baseQuery";

const createSemanticModelApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        semanticCreateConnection: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.SEMANTIC_CONNECTION_CREATE,
                method: "POST",
                body: payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        querySchema: build.query({
            query: (payload) => ({
                url: API_END_POINTS?.QUERY_SCHEMA + `?connection_key=${payload.connection_key}&search=${payload.search}`,
                method: "GET",
            }),
        }),

        queryWorkBentch: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.QUERY_WORKBENTCH,
                method: "POST",
                body: payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        connectionList: build.query({
            query: (params) => ({
                url: API_END_POINTS?.CONNECTION_LIST,
                method: "GET",
                params,
            }),
            providesTags: ["semanticModel"],
        }),

        makeQueries: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.MAKE_QUERIES,
                method: "POST",
                body: payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        getQueries: build.query({
            query: (val) => ({
                url: API_END_POINTS?.GET_QUERIES + `/?secret_key=${val}`,
                method: "GET",
            }),
            providesTags: ["semanticModel"],
        }),

        generateSemanticModel: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.GET_SEMANTIC_GENERATE,
                method: "POST",
                body: payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        modelList: build.query({
            query: (params) => ({
                url: API_END_POINTS?.GET_MODEL_LIST,
                method: "GET",
                params
            }),
            providesTags: ["semanticModel"],
        }),

        getConnectionData: build.query({
            query: (id) => ({
                url: API_END_POINTS?.CONNECTION_DATA + `/?connection_key=${id}`,
                method: "GET",
            }),
            providesTags: ["semanticModel"],
        }),

        featureStatusLink: build.mutation({
            query: (data) => ({
                url: API_END_POINTS?.FEATURE_STATUS_LINK,
                method: "POST",
                body: data
            }),
            invalidatesTags: ["semanticModel"],
        }),

        getRedirectionURL: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.GET_CHAT_REDIRECT_LINK + `?key=${payload?.key}`,
                method: "POST",
            }),
            invalidatesTags: ["semanticModel"],
        }),

        deleteEmbeddingModel: build.mutation({
            query: (payload) => ({
                url: API_END_POINTS?.EMBEDDING_MODEL_DELETE,
                method: "DELETE",
                body: payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        getWorkbenchModelData: build.query({
            query: ({secret_key}) => {
                const newParams = {secret_key}
                return {
                    url: API_END_POINTS.GET_WORKBENCH_MODEL_DATA,
                    method: "GET",
                    params: newParams
                }
            },
            providesTags: ["semanticModel"],
        }),

        generateSemanticQueries: build.mutation({
            query: ({payload, params}) => ({
                url: API_END_POINTS?.GENERATE_SEMANTIC_QUERIES,
                method: "POST",
                body: payload,
                params
            }),
            invalidatesTags: ["semanticModel"],
        }),

        getDraftEmbeddingModels: build.query({
            query: ({search, page, limit, connection_key}) => {
                const newParams = {search, page, limit, connection_key}
                return {
                    url: API_END_POINTS.DRAFT_EMBEDDING_MODELS,
                    method: "GET",
                    params: newParams
                }
            },
            providesTags: ["semanticModel"],
        }),
        connectionDelete:build.mutation({
            query:(payload)=>({
                url:API_END_POINTS.CONNECTION_DELETE,
                method:"DELETE",
                body:payload
            }),
            invalidatesTags: ["semanticModel"],
        }),

        exportEmbeddedModelResult: build.mutation({
            query: ({payload, params}) => ({
                url: API_END_POINTS.EMBED_MODEL_RESULT_EXPORT,
                method: "POST",
                body: payload,
                params
            }),
            invalidatesTags: ["semanticModel"],
        }),
    })
})

export const {
    useSemanticCreateConnectionMutation,
    useQuerySchemaQuery,
    useQueryWorkBentchMutation,
    useConnectionListQuery,
    useMakeQueriesMutation,
    useGetQueriesQuery,
    useGenerateSemanticModelMutation,
    useModelListQuery,
    useGetConnectionDataQuery,
    useGetRedirectionURLMutation,
    useFeatureStatusLinkMutation,
    useDeleteEmbeddingModelMutation,
    useGetWorkbenchModelDataQuery,
    useGenerateSemanticQueriesMutation,
    useGetDraftEmbeddingModelsQuery,
    useConnectionDeleteMutation,
    useExportEmbeddedModelResultMutation,
} = createSemanticModelApi